export default {"src":"/_next/static/media/BYBIT.41df1c7b.svg","height":28,"width":70,"blurWidth":0,"blurHeight":0};